import request from '@/config/axios'

export interface PackageItemVO {
  id?: number
  spuId: number
  skuId: number
  count: number
  spuName?: string
  picUrl?: string
  price?: number
}

export interface PackageActivityVO {
  id?: number
  name: string
  startTime: string
  endTime: string
  packagePrice: number
  totalCount: number
  userLimitCount: number
  soldCount?: number
  picUrl?: string
  remark?: string
  status?: number
  shopId?: number
  createTime?: string
  items: PackageItemVO[]
}

export const getPackageActivityPage = async (params: any) => {
  return await request.get({ url: '/promotion/package-activity/page', params })
}

export const getPackageActivity = async (id: number) => {
  return await request.get({ url: '/promotion/package-activity/get?id=' + id })
}

export const createPackageActivity = async (data: PackageActivityVO) => {
  return await request.post({ url: '/promotion/package-activity/create', data })
}

export const updatePackageActivity = async (data: PackageActivityVO) => {
  return await request.put({ url: '/promotion/package-activity/update', data })
}

export const closePackageActivity = async (id: number) => {
  return await request.put({ url: '/promotion/package-activity/close?id=' + id })
}

// 开启套餐活动
export const openPackageActivity = async (id: number) => {
  return await request.put({ url: '/promotion/package-activity/open?id=' + id })
}

export const deletePackageActivity = async (id: number) => {
  return await request.delete({ url: '/promotion/package-activity/delete?id=' + id })
}
